import P3PopularProjects from '../../components/toplist-24h-event/P3PopularProjects';
import { P3NewProjects } from './P3NewProjects';
import styles from './p3aksjonen.module.less';

const P3Toplists = ({ eventId }) => {
    return (
        <section className={styles.activityContainer}>
            <div className={styles.activityWrapper}>
                <P3NewProjects p3aEventId={eventId} />
                <P3PopularProjects eventId={eventId} />
            </div>
        </section>
    );
};

export default P3Toplists;
